var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen flex items-center justify-center text-center",attrs:{"id":"error_page"}},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"text-8xl mb-5 font-bold text-gray-500"},[_vm._v("404")]),_c('span',{staticClass:"text-2xl font-bold"},[_vm._v(" لأ توجد فاتورة بهذه المعلومات ")])])])
}]

export { render, staticRenderFns }